import { render, staticRenderFns } from "./ProductsCategories.vue?vue&type=template&id=019af80a&"
import script from "./ProductsCategories.vue?vue&type=script&lang=js&"
export * from "./ProductsCategories.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports